import { SAM_SEGMENT_ANNOTATION } from '../../../../constants';
export const isSAMSegmentAnnotation = annotation => SAM_SEGMENT_ANNOTATION.includes(annotation.type);